import { render, staticRenderFns } from "./CopyContentModal.vue?vue&type=template&id=343fbe39&scoped=true"
import script from "./CopyContentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyContentModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CopyContentModal.vue?vue&type=style&index=0&id=343fbe39&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343fbe39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343fbe39')) {
      api.createRecord('343fbe39', component.options)
    } else {
      api.reload('343fbe39', component.options)
    }
    module.hot.accept("./CopyContentModal.vue?vue&type=template&id=343fbe39&scoped=true", function () {
      api.rerender('343fbe39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/CopyContentModal.vue"
export default component.exports